import {Box, Col, ColRow, Flex, Grid} from '@indoqa/style-system'
import {IStyle} from 'fela'
import * as React from 'react'
import {useFela} from 'react-fela'
import {apis} from './apis'
import {authenticator} from './auth/SessionPlusAuthenticator'
import {ProtectedComponent} from './auth/ProtectedComponent'
import {Header} from './Header'
import {OverviewItem} from './OverviewItem'
import {Theme} from './theme'

export const Overview: React.FC = () => {
  const {css} = useFela<Theme>()
  const availableApis = apis.filter((api) => authenticator.hasPermission(api.permissions))
  const itemCols = availableApis.map((api) => {
    return (
      <Col size={4} key={api.path}>
        <OverviewItem name={api.name} linkTo={api.path}>
          {api.description}
        </OverviewItem>
      </Col>
    )
  })
  const emptyStateStyle: IStyle = {
    minHeight: 'calc(100vh - 45px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
  const content =
    availableApis.length === 0 ? (
      <div className={css(emptyStateStyle)}>
        <Flex direction="column" center bg="bgContentEmphasised" color="text" px={6} py={4}>
          <h1>Keine APIs verfügbar</h1>
          <Box pt={2}>
            Für Ihren Account sind derzeit keine API-Dokumentationen freigeschaltet.
          </Box>
        </Flex>
      </div>
    ) : (
      <Box px={2} pt={12} fullWidth>
        <Grid maxWidth={950} center spacing={'3rem'}>
          <ColRow>{itemCols}</ColRow>
        </Grid>
      </Box>
    )
  return (
    <ProtectedComponent>
      <div>
        <Header />
        {content}
      </div>
    </ProtectedComponent>
  )
}
